import React from 'react';
import { ChevronRight, Bookmark } from 'react-feather';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import SideMenuGroup from 'layouts/components/menu/vertical-menu/sidemenu/SideMenuGroup';
import { Badge } from 'reactstrap';
import { history } from 'history.js';
import { getRos } from 'redux/actions/dashboard';

const ITEM_TYPES = {
  ITEM: 'item',
  EXTERNAL_LINK: 'external-link',
  COLLAPSE: 'collapse',
  GROUP_HEADER: 'groupHeader',
};

class SideMenuContent extends React.Component {
  constructor(props) {
    super(props);

    this.parentArr = [];
    this.collapsedPath = null;
    this.redirectUnauthorized = () => {
      history.push('/misc/not-authorized');
    };
  }

  state = {
    flag: true,
    activeGroups: [],
    currentActiveGroup: [],
    tempArr: [],
    roHistoryConfigs: [],
  };

  handleGroupClick = (id, parent = null, type = '') => {
    const { ITEM, COLLAPSE } = ITEM_TYPES;
    let open_group = this.state.activeGroups;
    let active_group = this.state.currentActiveGroup;
    let temp_arr = this.state.tempArr;
    // Active Group to apply sidebar-group-active class
    if (type === ITEM && parent === null) {
      active_group = [];
      temp_arr = [];
    } else if (type === ITEM && parent !== null) {
      active_group = [];
      if (temp_arr.includes(parent)) {
        temp_arr.splice(temp_arr.indexOf(parent) + 1, temp_arr.length);
      } else {
        temp_arr = [];
        temp_arr.push(parent);
      }
      active_group = temp_arr.slice(0);
    } else if (type === COLLAPSE && parent === null) {
      temp_arr = [];
      temp_arr.push(id);
    } else if (type === COLLAPSE && parent !== null) {
      if (active_group.includes(parent)) {
        temp_arr = active_group.slice(0);
      }
      if (temp_arr.includes(id)) {
        // temp_arr.splice(temp_arr.indexOf(id), 1)
        temp_arr.splice(temp_arr.indexOf(id), temp_arr.length);
      } else {
        temp_arr.push(id);
      }
    } else {
      temp_arr = [];
    }

    if (type === COLLAPSE) {
      // If open group does not include clicked group item
      if (!open_group.includes(id)) {
        // Get unmatched items that are not in the active group
        let temp = open_group.filter(function (obj) {
          return active_group.indexOf(obj) === -1;
        });
        // Remove those unmatched items from open group
        if (temp.length > 0 && !open_group.includes(parent)) {
          open_group = open_group.filter(function (obj) {
            return !temp.includes(obj);
          });
        }
        if (open_group.includes(parent) && active_group.includes(parent)) {
          open_group = active_group.slice(0);
        }
        // Add group item clicked in open group
        if (!open_group.includes(id)) {
          open_group.push(id);
        }
      } else {
        // If open group includes click group item, remove it from open group
        open_group.splice(open_group.indexOf(id), 1);
      }
    }
    if (type === ITEM) {
      open_group = active_group.slice(0);
    }

    this.setState({
      activeGroups: open_group,
      tempArr: temp_arr,
      currentActiveGroup: active_group,
    });
  };

  initRender = (parentArr) => {
    this.setState({
      activeGroups: parentArr.slice(0),
      currentActiveGroup: parentArr.slice(0),
      flag: false,
    });
  };

  componentDidMount() {
    this.initRender(this.parentArr[0] ? this.parentArr[0] : []);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.activePath !== this.props.activePath) {
      if (this.collapsedMenuPaths !== null) {
        this.props.collapsedMenuPaths(this.collapsedMenuPaths);
      }

      this.initRender(this.parentArr[0] ? this.parentArr[this.parentArr.length - 1] : []);
    }

    if (prevProps.primaryCustomerId !== this.props.primaryCustomerId) {
      this.props.getRos(this.props.primaryCustomerId);
    }

    if (prevProps.ros !== this.props.ros && this.props.linkHash) {
      const [GREY, NONE] = ['grey', 'none'];
      const { EXTERNAL_LINK } = ITEM_TYPES;
      const roHistoryConfigs = this.props.ros.map(({ id, dateCreated, linkHash }) => ({
        id,
        title: dateCreated,
        type: EXTERNAL_LINK,
        icon: (
          <Bookmark size={20} color={GREY} fill={this.props.linkHash === linkHash ? GREY : NONE} />
        ),
        permission: [this.props.currentUser],
        navLink: '/' + linkHash,
      }));
      this.setState({ roHistoryConfigs });
    }
  }

  render() {
    const { EXTERNAL_LINK, GROUP_HEADER, ITEM, COLLAPSE } = ITEM_TYPES;
    const menuItems = this.state.roHistoryConfigs.map((item) => {
      /** each hash link requires external tag for auth purposes on the linkHash */
      const CustomAnchorTag = item.type === EXTERNAL_LINK ? `a` : Link;
      if (item.type === GROUP_HEADER) {
        return (
          <li className="navigation-header" key={`group-header-${item.groupTitle}`}>
            <span>{item.groupTitle}</span>
          </li>
        );
      }

      let renderItem = (
        <li
          className={classnames('nav-item', {
            'has-sub': item.type === COLLAPSE,
            open: this.state.activeGroups.includes(item.id),
            'sidebar-group-active': this.state.currentActiveGroup.includes(item.id),
            hover: this.props.hoverIndex === item.id,
            active:
              (this.props.activeItemState === item.navLink && item.type === ITEM) ||
              (item.parentOf && item.parentOf.includes(this.props.activeItemState)),
            disabled: item.disabled,
          })}
          key={item.id}
          onClick={(e) => {
            e.stopPropagation();
            if (item.type === ITEM) {
              this.props.handleActiveItem(item.navLink);
              this.handleGroupClick(item.id, null, item.type);
              if (this.props.deviceWidth <= 1200 && item.type === ITEM) {
                this.props.toggleMenu();
              }
            } else {
              this.handleGroupClick(item.id, null, item.type);
            }
          }}
        >
          <CustomAnchorTag
            to={
              item.filterBase
                ? item.filterBase
                : item.navLink && item.type === ITEM
                  ? item.navLink
                  : ''
            }
            href={item.type === EXTERNAL_LINK ? item.navLink : ''}
            className={`d-flex ${
              item.badgeText ? 'justify-content-between' : 'justify-content-start'
            }`}
            onMouseEnter={() => {
              this.props.handleSidebarMouseEnter(item.id);
            }}
            onMouseLeave={() => {
              this.props.handleSidebarMouseEnter(item.id);
            }}
            key={item.id}
            onClick={(e) => {
              return item.type === COLLAPSE ? e.preventDefault() : '';
            }}
            target={item.newTab ? '_blank' : undefined}
          >
            <div className="menu-text">
              {item.icon}
              <span className="menu-item menu-title">{item.title}</span>
            </div>

            {item.badge ? (
              <div className="menu-badge">
                <Badge color={item.badge} className="mr-1" pill>
                  {item.badgeText}
                </Badge>
              </div>
            ) : (
              ''
            )}
            {item.type === COLLAPSE ? <ChevronRight className="menu-toggle-icon" size={13} /> : ''}
          </CustomAnchorTag>
          {item.type === COLLAPSE ? (
            <SideMenuGroup
              group={item}
              handleGroupClick={this.handleGroupClick}
              activeGroup={this.state.activeGroups}
              handleActiveItem={this.props.handleActiveItem}
              activeItemState={this.props.activeItemState}
              handleSidebarMouseEnter={this.props.handleSidebarMouseEnter}
              activePath={this.props.activePath}
              hoverIndex={this.props.hoverIndex}
              initRender={this.initRender}
              parentArr={this.parentArr}
              triggerActive={undefined}
              currentActiveGroup={this.state.currentActiveGroup}
              permission={this.props.permission}
              currentUser={this.props.currentUser}
              redirectUnauthorized={this.redirectUnauthorized}
              collapsedMenuPaths={this.props.collapsedMenuPaths}
              toggleMenu={this.props.toggleMenu}
              deviceWidth={this.props.deviceWidth}
            />
          ) : (
            ''
          )}
        </li>
      );

      if (item.navLink && item.collapsed !== undefined && item.collapsed === true) {
        this.collapsedPath = item.navLink;
        this.props.collapsedMenuPaths(item.navLink);
      }

      if (
        item.type === COLLAPSE ||
        item.type === EXTERNAL_LINK ||
        (item.type === ITEM &&
          item.permissions &&
          item.permissions.includes(this.props.currentUser)) ||
        item.permissions === undefined
      ) {
        return renderItem;
      } else if (
        item.type === ITEM &&
        item.navLink === this.props.activePath &&
        !item.permissions.includes(this.props.currentUser)
      ) {
        return this.redirectUnauthorized();
      }
    });
    return <React.Fragment>{menuItems}</React.Fragment>;
  }
}

const mapStateToProps = (state) => ({
  ros: state.dashboard.ros,
  primaryCustomerId: state.dashboard.repairOrder?.primaryCustomer?.id,
  linkHash: state.auth.linkHash,
});

export default connect(mapStateToProps, { getRos })(SideMenuContent);
